<template>
	<div class="w-100 multisel-dynamix-flex">
		<label id="hideinmobile" v-if="!noLabel" class="teams-label-font w-40"
			>{{ label }}<span v-if="mandatory" class="asterik">*</span></label
		>
		<div class="select-div w-100 position-relative">
			<div
				ref="landingdrop"
				@click="openDropdown = !openDropdown"
				class="selectCustom-field d-flex align-items-center justify-content-between floating-label"
				:class="{ error: showError }"
			>
				<span class="inputPlaceholder-font">
					{{
						selectedValues.length > 0
							? `${selectedValues.length} ${label} selected`
							: ""
					}} </span
				><img
					class="access-validationicon-2"
					src="../../assets/newdesign/inputcomponent/blueDownArrow.svg"
					alt=""
				/>
				<label id="hideinlaptop" :class="{ active: selectedValues.length }"
					>{{ label
					}}<span v-if="mandatory" class="asterik">&nbsp;*</span></label
				>
			</div>
			<div
				v-closable="{
					exclude: ['landingdrop'],
					handler: 'hideLandingDropdown',
				}"
				v-if="openDropdown"
				class="selectCustom-dropdown pointer newManage-checkbox"
			>
				<b-form-checkbox-group
					v-model="selectedValues"
					:options="dropDownOptions"
					class="w-100 selectCustom-dropdown-innerContent"
					value-field="key"
					text-field="label"
					disabled-field="notEnabled"
					@change="$emit('select-value', selectedValues)"
				></b-form-checkbox-group>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "MultiSelectCustom",
	props: {
		noLabel: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		dropdown: Boolean,
		label: String,
		placeholder: String,
		id: String,
		fieldType: String,
		api: String,
		values: Array,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	data() {
		return {
			openDropdown: false,
			search: "",
			value: "",
			dropDownOptions: [],
			selectedValues: [],
			defaultKey: null,
		};
	},
	computed: {
		...mapGetters("userVUEX", {
			licenseKey: "getlicenseKey",
		}),
	},
	created() {
		console.log("me");
		console.log(this.dropdown, this.values);
		if (this.dropdown) {
			this.dropDownOptions = this.values;
		} else {
			this.getDropdownOptions();
		}
		if (this.vmodel) {
			this.selectedValues = this.vmodel;
			if (this.id != "coOrdinators") {
				this.checkDefaultOption();
				this.selectedValues = this.selectedValues.filter((value) =>
					this.dropDownOptions.some((option) => option.key === value)
				);
			}
		} else {
			this.checkDefaultOption();
		}
	},
	methods: {
		checkDefaultOption() {
			if (this.dropdown) {
				const defaultOptions = this.dropDownOptions.filter(
					(option) => option.isDefault
				);
				defaultOptions.forEach((defaultOption) => {
					if (!this.selectedValues.includes(defaultOption.key)) {
						this.selectedValues.push(defaultOption.key);
					}
				});
			}
		},
		async getDropdownOptions() {
			console.log("Call any API if requiredY");
		},
		hideLandingDropdown() {
			this.openDropdown = false;
		},
	},
};
</script>
<style>
@media (min-width: 1029px) {
	.multisel-dynamix-flex {
		display: flex;
		justify-content: space-between;
	}
}
@media only screen and (max-width: 1028px) {
	.selectCustom-dropdown::-webkit-scrollbar {
		width: 5px !important;
		height: 5px !important;
	}
}
</style>
